import { z } from 'zod/v4'
import { WorkflowNodeBaseSchema } from '../../../resources/types'

const ContactResolveInputsSchema = z.object({
  'instance-id': z
    .string()
    .describe('CRM instance ID to resolve to a conversation contact'),
})

const ContactResolveOptionsSchema = z.object({})

export const ContactResolveCommandSchema = WorkflowNodeBaseSchema.extend({
  service: z.object({
    name: z.literal('skedyul/conversations'),
    cmd: z.literal('contact.resolve'),
    options: ContactResolveOptionsSchema.optional(),
  }),
  inputs: ContactResolveInputsSchema,
})

export type ContactResolveCommand = z.infer<typeof ContactResolveCommandSchema>
